<template>
    <div class="container" v-if="artistGeneral">
        <ProfileTitle>
            <template v-slot:header>
                <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s">{{artistGeneral.first_name}} {{artistGeneral.last_name}}</h1>
                <ul class="main__breadcrumbs wow zoomIn" data-wow-duration="1.5s">
                    <li><a href="">Artists</a></li>
                    <li>{{artistGeneral.first_name}} {{artistGeneral.last_name}}</li>
                </ul>
            </template>
        </ProfileTitle>

        <TabContainer :tabs="artistTabs" :space-between="true" />
    </div>
</template>


<script>
import ProfileTitle from "../Common/ProfileTitle.vue";
import TabContainer from "../Common/TabContainer.vue";
import ArtistGallery from "./ArtistGallery.vue";
import ArtistShows from "./ArtistShows.vue";
import ArtistAvailability from "./ArtistAvailability.vue";
import ArtistBooking from "./ArtistBooking.vue";
import {mapActions, mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import ArtistInformationTab from "./ArtistInformationTab.vue";
import ArtistBankInformation from "./ArtistBankInformation.vue";
import ArtistGroupMembers from "./ArtistGroupMembers.vue";
import ArtistPersonalInfoTab from "./ArtistPersonalInfoTab.vue";
import AdminService from "../../services/AdminService";

export default {
    name: 'ArtistProfile',
    components: {TabContainer, ProfileTitle},
    props: {
        artistId: {
            type: Number,
            required: false
        },
    },
    data() {
        return {
            artistTabs: [
                { id: 1, name: 'Artist Information', component: ArtistInformationTab },
                { id: 2, name: 'Photo/Video Gallery', component: ArtistGallery },
                { id: 3, name: 'Shows', component: ArtistShows },
                { id: 4, name: 'Availability', component: ArtistAvailability },
                { id: 5, name: 'Booking', component: ArtistBooking },
                { id: 6, name: 'Personal Info', component: ArtistPersonalInfoTab },
                { id: 7, name: 'Bank Info', component: ArtistBankInformation },
                { id: 8, name: 'Group Members', component: ArtistGroupMembers },
            ],
        };
    },
    computed: {
        ...mapState(useArtistStore, {
            artistGeneral: 'artistGeneralInfo',
        }),
    },
    methods: {
        ...mapActions(useArtistStore, {
            getArtistInfo: 'fetchArtistFromAdmin',
            fetchArtist: 'fetchArtist',
            fetchCompanies: 'fetchCompanies',
            setAdminPermission: 'setAdminPermission',
            getCurrentUser: 'getCurrentUser',
            fetchRegionList: 'fetchRegionList'
        }),

    },
    mounted() {
        if (this.artistId) {
            this.setAdminPermission()
        }
        this.fetchArtist(this.artistId)
        this.fetchCompanies()
        this.getCurrentUser()
        this.fetchRegionList();
    }
}

</script>


<style scoped>

</style>
